export default __webpack_public_path__ + "travel_assist_favicon.ico";